import { render, staticRenderFns } from "./modal-wrapper-mobile.vue?vue&type=template&id=54438b6f&scoped=true&"
import script from "./modal-wrapper-mobile.vue?vue&type=script&lang=ts&"
export * from "./modal-wrapper-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./modal-wrapper-mobile.vue?vue&type=style&index=0&id=54438b6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54438b6f",
  null
  
)

export default component.exports